import React from 'react'
import './Body.css'
function Body() {
  return (
    <section>

  <div>
  <html>
  <body>
<section>
     <div className="container" >
       <img className="Body-img" src="https://images.unsplash.com/photo-1432821596592-e2c18b78144f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=100%&q=100px"/>

  </div>
  <div className="body-Center">
  <h4>Hi,I am Harshit Agrawal</h4>
  <h6>I am a passionate coder,who loves to code not depend what launguage is that.Need a good internet connection and laptop and that will my different paradise.Sometimes a web devloper and Sometimes SDE.</h6>
</div>



</section>
  </body>
</html>

        </div>
</section>

  )
}

export default Body;
